import styled from "styled-components";

const TableScrollWrap = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export default TableScrollWrap;
